import { Component, inject } from '@angular/core';
import { PatrimonyActivityParameterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  PatrimonyActivityParameterCreateDto,
  PatrimonyActivityParameterDto,
  PatrimonyActivityParameterExcelDownloadDto,
  PatrimonyActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/patrimony-activity-parameter';
import { PATRIMONYACTIVITYPARAMETER_CONFIG, PATRIMONYACTIVITYPARAMETER_FIELDS } from './patrimony-activity-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-patrimony-activity-parameter',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, PatrimonyActivityParameterService, ConfirmationService],
  templateUrl: './patrimony-activity-parameter.html',
  styleUrl: './patrimony-activity-parameter.scss',
})
export class PatrimonyActivityParameter extends BaseHierarchicalCrudComponent<
  PatrimonyActivityParameterDto,
  PatrimonyActivityParameterCreateDto,
  PatrimonyActivityParameterUpdateDto,
  PatrimonyActivityParameterExcelDownloadDto
> {
  service = inject(PatrimonyActivityParameterService);
  config = PATRIMONYACTIVITYPARAMETER_CONFIG;
  fields = PATRIMONYACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: PatrimonyActivityParameterDto): PatrimonyActivityParameterUpdateDto {
    return {
      mustHavePrice: data.mustHavePrice,
      isCalculated: data.isCalculated,
      projectOrder: data.projectOrder,
      isVisible: data.isVisible,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      levelId: data.levelId,
      activityToolId: data.activityToolId,
      activityReasonId: data.activityReasonId,
      wbsId: data.wbsId,
      workTypeId: data.workTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PatrimonyActivityParameter';
  }
}
